import React from 'react'
import { PrivateRoute } from 'components/WithAuth'
import {
  ScheduledInvoiceList,
  InvoiceList,
  Invoice,
  InvoicePayments,
  Details,
  Log,
  Keys,
  EditPersonalia,
  ManageMember,
  FreezeList,
  Referrals,
  Comments,
  MemberBillingAdjustments
} from '../../index'
import { NoAccessComponent } from 'scenes/NoAccess'
import { UnderDevelopmentComponent } from 'scenes/UnderDevelopment'
import { NavLink } from 'react-router-dom'
import { hasAccess, featureEnabled } from 'components/Helpers'

const IndexNavItem = ({ basePath, txt }) =>
  <li>
    <NavLink exact to={basePath}>
      {txt}
    </NavLink>
  </li>

const NavItem = ({ basePath, match, path, label = null }) =>
  <li>
    <NavLink to={`${basePath}/${path}`}>
      {label || path}
    </NavLink>
  </li>

const navItems = (user) => {
  const items = [
    { path: 'invoices', label: 'Invoices' },
    { path: 'log', label: 'Log' },
    { path: 'freeze/list', label: 'Freeze' },
    { path: 'keys', label: 'Keys' },
    { path: 'referrals', label: 'Referrals' },
    { path: 'comments', label: 'Comments' }
  ]

  if (featureEnabled('membBillAdj', user.operator) && hasAccess(user, 'memberships.manage_billing_adjustments')) {
    items.push({ path: 'billing-adjustments/list', label: 'Billing Adjustments' })
  }

  return items
}

const MainNavItems = (props) => {
  return (
    <ul>
      <IndexNavItem txt='Details' {...props} />
      {navItems(props.user).map((ni, i) => <NavItem {...ni} {...props} key={`nav${i}`} />)}
    </ul>
  )
}

const ManageMemberNavItems = (props) =>
  <ul>
    <IndexNavItem txt='General' {...props} />
    <NavItem path='product' {...props} />
    <NavItem path='promotions' {...props} />
  </ul>

const Navigation = (props) => {
  switch (props.subPage) {
    case 'Edit Personalia':
      return ''
    case 'Manage membership':
      return (<ManageMemberNavItems basePath={`${props.match.url}/manage`} />)
    default:
      return (<MainNavItems basePath={props.match.url} {...props} />)
  }
}

const ManageMemberRoute = ({ component, path, ...props }) =>
  <PrivateRoute
    exact path={`${props.match.url}/${path}`}
    permission='memberships.manage_memberships'
    component={component}
    header='Manage Member'
    {...props}
  />

const ManageMemberRoutes = (props) =>
  <span>
    <ManageMemberRoute
      path='manage'
      component={ManageMember}
      {...props}
    />
    <ManageMemberRoute
      path='manage/product'
      component={ManageMember}
      {...props}
    />
    <ManageMemberRoute
      path='manage/promotions'
      component={ManageMember}
      {...props}
    />
    <ManageMemberRoute
      path='manage/no-access'
      component={NoAccessComponent}
      {...props}
    />
  </span>

const MemberRouteAndNavigation = (props) =>
  <div className='menu-bar'>
    <Navigation {...props} />
    <PrivateRoute
      exact path={`${props.match.url}`}
      permission='memberships.view_memberships'
      component={Details}
      {...props}
    />
    <PrivateRoute
      exact path={`${props.match.url}/edit`}
      permission='memberships.manage_member_details'
      component={EditPersonalia}
      header='Edit Personalia'
      {...props}
    />
    <ManageMemberRoutes {...props} />
    <PrivateRoute
      exact path={`${props.match.url}/invoices`}
      permission='memberships.view_memberships'
      component={InvoiceList}
      {...props}
    />
    <PrivateRoute
      exact path={`${props.match.url}/scheduled-invoices`}
      permission='memberships.view_memberships'
      component={ScheduledInvoiceList}
      {...props}
    />
    <PrivateRoute
      exact path={`${props.match.url}/invoices/:invoiceID`}
      permission='memberships.view_memberships'
      component={Invoice}
      {...props}
    />
    <PrivateRoute
      exact path={`${props.match.url}/invoices/:invoiceID/payments`}
      permission='memberships.view_memberships'
      component={InvoicePayments}
      {...props}
    />
    <PrivateRoute
      exact path={`${props.match.url}/log`}
      permission='memberships.view_memberships'
      component={Log}
      {...props}
    />
    <PrivateRoute
      path={`${props.match.url}/log/:logID`}
      permission='memberships.view_memberships'
      component={NoAccessComponent}
      {...props}
    />
    <PrivateRoute
      path={`${props.match.url}/keys`}
      permission='memberships.view_memberships'
      component={Keys}
      subComponent
      {...props}
    />
    <PrivateRoute
      path={`${props.match.url}/freeze`}
      permission='memberships.view_memberships'
      component={FreezeList}
      freezePeriods={props.member.freeze_periods}
      subComponent
      {...props}
    />
    <PrivateRoute
      path={`${props.match.url}/referrals`}
      permission='memberships.view_memberships'
      component={Referrals}
      operator={props.member.operator_id}
      subComponent
      {...props}
    />
    <PrivateRoute
      path={`${props.match.url}/comments`}
      permission='memberships.view_memberships'
      component={Comments}
      operator={props.member.operator_id}
      subComponent
      {...props}
    />
    <PrivateRoute
      path={`${props.match.url}/billing-adjustments`}
      permission='memberships.manage_billing_adjustments'
      component={MemberBillingAdjustments}
      operator={props.member.operator_id}
      subComponent
      {...props}
    />
    <PrivateRoute
      path={`${props.match.url}/no-access`}
      permission='memberships.view_memberships'
      component={NoAccessComponent}
      subComponent
      {...props}
    />
    <PrivateRoute
      path={`${props.match.url}/under-development`}
      permission='memberships.manage_memberships'
      component={UnderDevelopmentComponent}
      subComponent
      {...props}
    />
  </div>

export default MemberRouteAndNavigation
